(function containerTypeControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminContainerTypeService', 'authExtend', 'functionService', '$filter','storageService',
            function containerTypeController($scope, config, $state, $translate, errors, adminContainerTypeService, authExtend, functionService, $filter, storageService) {

                $scope.find = storageService.getContainerTypeFilter();
                $scope.items = [];
                $scope.hideAddBtn = !authExtend.isInRole('CONTAINERTYPE WRITE');
                $scope.hideImportExportBtn = !authExtend.isInRole('CTDT EXPORT IMPORT');
                $scope.editAll = authExtend.isInRole('CONFIG ADMIN APPS') || authExtend.isInRole('CONTAINERTYPE WRITE');
                $scope.edrAppId = config.appId();
                $scope.enableviewIndex = authExtend.isInRole('VIEW INDEX') || authExtend.isInRole('EDIT AND DELETE INDEX');

                if ($scope.editAll) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.exportAllSelectedContainerTypes = function () {
                    var containerTypesToExport = [];
                    $scope.items.forEach(function (containerType) {
                        if (containerType.check) {
                            containerTypesToExport.push(containerType.id);
                        }
                    });

                    if (containerTypesToExport.length > 0) {
                        $scope.exportContainerTypes(containerTypesToExport);
                    }
                    else {
                        errors.showError("Debe Seleccionar al menos un Tipo de Carpeta para exportar");
                    }
                };

                $scope.exportContainerTypes = function (containerTypesToExport) {
                    var parameter = { version: "1", ids: containerTypesToExport };
                    return adminContainerTypeService.exportToJson(parameter).then(function (result, data) {
                        console.log(result.headers);
                        var file = new Blob([result]);
                        var today = new Date();
                        var filename = "Export_DefinicionTC_" + $scope.find.organizationalUnitName + "_" + $filter('date')(today, "yyyyMMdd") + ".zip";

                        saveAs(file, filename);
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.import = function () {
                    $state.go('container-type-import');
                };

                $scope.findAction = function () {

                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.checkAll = false;
                    storageService.setContainerTypeFilter($scope.find);
                    return adminContainerTypeService.get($scope.find.Name, $scope.find.organizationalUnitId, $scope.find.app ? $scope.find.app.id : undefined).then(function getOk(result) {
                        $scope.items = result;

                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.modify = function (container) {
                    $state.go('container-type-modify', { id: container.id });
                };

                $scope.add = function () {
                    $state.go('container-type-add');
                };

                $scope.metadata = function (container) {
                    $state.go('container-type-metadata', { id: container.id });
                };

                $scope.documentType = function (container) {
                    $state.go('container-type-document-type', { id: container.id });
                };

                $scope.view = function (container) {
                    $state.go('container-type-detail', { id: container.id });
                };

                $scope.importSettings = function (container) {
                    $state.go('container-type-import-settings', { id: container.id });
                };

                $scope.viewIndex = function (container) {
                    $state.go('dba-detail', { key: 'TC', id: container.id });
                };

                $scope.containerTypeShareable = function (container, isShareable) {
                    if (isShareable) {
                        return adminContainerTypeService.share(container).then(function () {
                            errors.showSuccess('ContainerTypeShareableSucces');
                            container.isShareable = isShareable;
                        }, function (error) {
                            errors.showError(error);
                        });
                    } else {
                        return adminContainerTypeService.notShare(container).then(function () {
                            container.isShareable = isShareable;
                            errors.showSuccess('ContainerTypeNotShareableSucces');
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.findAction();
            }
        ]);
})();